import React from 'react'

interface IFacebook {
  width?: string
  height?: string
}

const Facebook: React.FC<IFacebook> = ({ width = '27', height = '26' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0V26H27V0H0ZM17.8618 7.15526H15.7514C15.3334 7.15526 14.9115 7.57126 14.9115 7.88074V9.95297H17.8576C17.739 11.5419 17.4955 12.995 17.4955 12.995H14.8965V22H11.0235V12.994H9.13822V9.96377H11.0235V7.48629C11.0235 7.03326 10.9282 4.00006 14.9918 4.00006H17.8618V7.15526H17.8618Z"
      fill="#262A44"
    />
  </svg>
)

export default Facebook
